import i18n from '@crest/web-common/i18n.js';
import '@crest/web-common/styles/index.css';
import '@crest/web-common/styles/mobile-contract.css';
import '@crest/web-common/styles/theme-tokens.css';
import {
  applyCrestThemeToElement,
  getStoredCrestTheme,
} from '@crest/web-common/theme/crest-theme-preference.js';
import { createRoot } from 'react-dom/client';
import { PlatformApp } from './App.js';
import './platform.css';

// 首帧前写入主题，避免天蓝/橙色切换闪烁。
applyCrestThemeToElement(getStoredCrestTheme());
document.documentElement.lang = i18n.language?.startsWith('en') ? 'en' : 'zh-CN';
i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language.startsWith('en') ? 'en' : 'zh-CN';
});

const node = document.getElementById('root');
if (!node) throw new Error('CREST 平台挂载节点不存在');
createRoot(node).render(<PlatformApp />);
